import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestJobGet = {
    path: "/job/:id",
    method: RouteHttpVerb.GET
};
